import CommonTable, {
  IActionData,
  ITableColumn,
} from '@/components/common/CommonTable';
import MainHeading from '@/components/common/MainHeading';
import PlusIcon from '@/components/Icons/PlusIcon';
import CardLayout from '@/components/Layout/CardLayout';
import Layout from '@/components/Layout/Layout';
import { useCallback, useEffect, useState } from 'react';
import AddDepartmentModal, { IAddDepartmentForm } from './AddDepartmentModal';
import { API_ENDPOINT, API_URL } from '@/api/constant';
import { callApi, IApiErrorResponse } from '@/api/callApi';
import EditIcon from '@/components/Icons/EditIcon';
// import DeleteIcon from '@/components/Icons/DeleteIcon';
import {
  IDepartmentPageState,
  IDepartmentResponse,
} from '@/interfaces/department.model';
import { IHolidayModal } from '@/interfaces/holiday.model';
import { IDeleteResponse } from '@/interfaces/common.model';
import { getFilterUrl, showToastNotification } from '@/utility/helper';
import useFilter from '@/hooks/useFilter';
import FilterComponent from '@/components/common/FilterComponent';
import { useSelector } from 'react-redux';
import { RootState } from '@/redux/store';

const Department: React.FC = () => {
  const [modal, setModal] = useState<IHolidayModal>({
    updateData: false,
    deleteData: false,
  });
  const tableView = useSelector((state: RootState) => state?.user?.tableView);
  const filterDetails = useSelector(
    (state: RootState) => state?.user?.filtersStates,
  );
  const [editData, setEditData] = useState<IAddDepartmentForm | null>(null);
  const toggleModal = (type?: string) => {
    setModal((pre) => ({
      ...pre,
      ...(type === 'delete'
        ? { deleteData: !pre.deleteData }
        : { updateData: !pre.updateData }),
    }));
  };
  const [pageStates, setPageStates] = useState<IDepartmentPageState>({
    currentPage: 1,
    count: 0,
    totalPages: 0,
    tableLoader: false,
    department: [],
    searchQuery: '',
  });

  const getDepartment = useCallback(async () => {
    try {
      setPageStates((prev) => ({
        ...prev,
        tableLoader: true,
      }));
      const filter = {
        search: pageStates.searchQuery,
        pageSize: filterDetails?.pageSize,
        pageNumber: pageStates.currentPage,
      };
      const API = `${API_URL}${API_ENDPOINT?.getDepartment}?${getFilterUrl(filter)}`;
      const response: IDepartmentResponse = await callApi(API, {
        method: 'GET',
      });
      if (response.status === true) {
        const newData: IAddDepartmentForm[] = response?.data?.department?.map(
          (item, index) => ({
            ...item,
            index: index + 1,
            name: item?.name,
            toggleStatus: item?.isActive,
          }),
        );
        setPageStates((prev) => ({
          ...prev,
          count: response?.data?.pageInfo?.total ?? 0,
          totalPages: response?.data?.pageInfo.totalPages,
          department: newData,
          currentPage: response?.data?.pageInfo?.currentPage,
          tableLoader: false,
        }));
      }
    } catch (error) {
      if (error && typeof error === 'object' && 'message' in error) {
        showToastNotification('danger', (error as IApiErrorResponse).message);
      } else {
        showToastNotification('danger', 'Something went wrong');
      }
    } finally {
      setPageStates((prev) => ({
        ...prev,
        tableLoader: false,
      }));
    }
  }, [filterDetails?.pageSize, pageStates.currentPage, pageStates.searchQuery]);

  useEffect(() => {
    getDepartment();
  }, [getDepartment]);

  const tableHeading: ITableColumn<IAddDepartmentForm>[] = [
    { value: 'index', label: '#' },
    { value: 'name', label: 'Department Name' },
    { value: 'toggleStatus', label: 'Status' },
  ];

  const handleEdit = (data: IAddDepartmentForm) => {
    setEditData(data);
    toggleModal();
  };
  const ActionData: IActionData<IAddDepartmentForm>[] = [
    {
      label: 'Edit',
      className: 'btn btn-link border-0 py-2 m-1 ',
      icon: <EditIcon />,
      title: 'edit',
      clickHandler: handleEdit,
      isHidden: (data) => data?.name === 'Intern',
    },
  ];
  // {
  //   label: <i className="fas fa-trash-alt" />,
  //   className: 'btn btn-success border-0 text-danger bg-danger-subtle py-2',
  //   icon: <DeleteIcon />,
  //   title: 'delete',
  //   clickHandler: ActionHandler,
  // },

  // const HandleDelete = async () => {
  //   setIsLoading(true);
  //   try {
  //     const API = `${API_URL}${API_ENDPOINT.deleteDepartment}?departmentId=${selectedId}`;
  //     const response: IDeleteResponse = await callApi(API, {
  //       method: 'GET',
  //     });
  //     setIsLoading(false);
  //     if (response?.status === true) {
  //       showToastNotification('success', response?.message);
  //       toggleModal('delete');
  //       getDepartment();
  //     } else {
  //       showToastNotification('danger', response?.message);
  //       toggleModal('delete');
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };
  const handleStatusToggle = async (
    data: IAddDepartmentForm,
    status: boolean,
  ) => {
    const postData = {
      name: data?.name,
      isActive: !status,
    };
    const updatedDepartment = pageStates?.department.map((dep) => {
      if (dep?.id == data?.id) {
        return { ...dep, toggleStatus: !status, isActive: !status };
      }
      return dep;
    });
    setPageStates((prev) => ({ ...prev, department: updatedDepartment }));
    try {
      const response: IDeleteResponse = await callApi(
        API_URL + API_ENDPOINT.updateDepartment + `?departmentId=${data?.id}`,
        {
          method: 'POST',
          data: postData,
        },
      );
      if (response?.status) {
        showToastNotification('success', response?.message);
        // getDepartment();
      }
    } catch (error: unknown) {
      const updateCompanyList = pageStates.department.map((dep) => {
        if (dep.id === data.id) {
          return {
            ...dep,
            toggleStatus: status,
          };
        }
        return dep;
      });
      setPageStates((prev) => ({ ...prev, department: updateCompanyList }));
      if (error && typeof error === 'object' && 'message' in error) {
        showToastNotification('danger', (error as IApiErrorResponse).message);
      } else {
        showToastNotification('danger', 'Something went wrong');
      }
    }
  };
  const { pageChangeHandler, handleSearchChange, handleChangePageSize } =
    useFilter(pageStates, setPageStates);
  return (
    <>
      <Layout>
        <div className="content">
          <MainHeading
            title={'Department'}
            buttonText={'Add Department'}
            buttonIcon={<PlusIcon />}
            clickHandler={toggleModal}
          />
        </div>
        <CardLayout isGrid={tableView === 'grid'}>
          <FilterComponent handleSearch={handleSearchChange} isGrid={false} />
          <CommonTable
            handleStatusToggle={handleStatusToggle}
            tableHeading={tableHeading}
            tableData={pageStates?.department}
            ActionData={ActionData}
            count={pageStates?.count}
            pageSize={filterDetails?.pageSize}
            isLoading={pageStates?.tableLoader}
            totalPages={pageStates?.totalPages}
            currentPage={pageStates?.currentPage}
            handleChangePageSize={handleChangePageSize}
            pageChangeHandler={pageChangeHandler}
          />
        </CardLayout>
      </Layout>
      <AddDepartmentModal
        isOpen={modal?.updateData}
        onClose={() => {
          toggleModal();
          setEditData(null);
        }}
        EditData={editData}
        getDepartment={getDepartment}
      />
    </>
  );
};

export default Department;
